'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
var $d_Ljava_time_ZoneRegion = new $j_java$002elang$002e$002dObject.$TypeData().i(0, "java.time.ZoneRegion", ({
  lb: 1,
  dC: 1,
  a: 1
}));
export { $d_Ljava_time_ZoneRegion as $d_Ljava_time_ZoneRegion };
